import { render, staticRenderFns } from "./CreateEditGenotypeCombinations.vue?vue&type=template&id=89c5a8ec&scoped=true&"
import script from "./CreateEditGenotypeCombinations.vue?vue&type=script&lang=js&"
export * from "./CreateEditGenotypeCombinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c5a8ec",
  null
  
)

export default component.exports